<template>
    <div name="card-update" class="wrapper">
        <loading v-if="isLoading" />
        <card-change-modal 
            :token="token"
            v-if="isCardChangeModal"
            @onClose="onCloseCardChangeModal"
            :profile_id="profileId"
        />
        <common-modal 
            v-if="isCardDeleteModal"
            :title="'카드 삭제 안내'"
            :message="'삭제 후엔 되돌릴 수 없어요.<br>정말로 삭제하시겠습니까?'"
            :button1Text="'네, 삭제해주세요'"
            :button2Text="'아니요'"
            :buttonCount="2"
            @onClose="closeCardDeleteModal"
            @onClickButton1="deleteCardCall"
            @onClickButton2="closeCardDeleteModal"
        />
        <div class="page" v-else>
            
            <error-modal 
                v-if="error"
                :error="error"
                @onClose="onErrorModalClose"
            />
            <div class="button-header">
                <img @click="back" style="width: 13.5px; cursor: pointer;" src="../assets/arrow_back.png" />
            </div>
            <div class="contents-header">
                <span class="text1">결제 카드를 등록해 주세요</span>
                <span class="text2" style="margin-top: 16px;">
                    <span class="text3">비대면진료/소모성재료 결제</span>
                        를 위한 한 번의 카드 등록!
                </span>
                <!-- <span class="text2" style="margin-top: 8px;">
                    <span class="text3" style="color: var(--Blue-01_Primary-blue, #008DEF);">하나카드</span>는 현재 지원하지 않습니다. 다른 카드사를 이용해 주세요.
                </span> -->
            </div>
            <div class="contents-body">
                <text-label 
                    :text="'환자선택'"
                    :isDefault="true"
                />
                <div class="name-button-list">
                    <div v-for="(info, index) in diabetes_profiles" style="margin-right: 16px;">
                        <div class="name-button-active" v-if="activeProfileId === index">
                            {{ info.profile.name }}
                        </div>
                        <div class="name-button-inactive" v-else @click="selectProfile(index)">
                            {{ info.profile.name }}
                        </div>
                    </div>

                </div>
                <div class="row" style="margin-top: 8px;">
                    <span class="info-text">환자를 선택하면 <span class="info-color-text">등록된 결제카드</span>를 확인할 수 있어요</span>
                </div>   
                <text-label 
                    :text="'등록된 결제 카드'"
                    :isDefault="false"
                />
                <div class="card-area" v-if="diabetes_profiles[activeProfileId].card_info != null">                     
                    <span class="text6">{{ diabetes_profiles[activeProfileId].card_info.card_name }}</span>
                    <span class="text7" style="margin-top: 11px;">{{ diabetes_profiles[activeProfileId].card_info.card_number }}</span>                    
                    <div class="row" style="margin-top: 14px; gap: 8px">
                        <div class="card-update-button" @click="changeCard">변경</div>
                        <div class="card-update-button" @click="deleteCard">삭제</div>
                    </div> 
                </div>
                <div class="plus-button" v-else style="margin-top: 16px;" @click="changeCard">
                    <img style="width: 22px;" src="../assets/plus_btn.png" />
                    <span style="margin-left: 16px;">결제카드 등록</span>
                </div>

                <span class="text2" style="margin-top: 8px;">
                    카드 변경이 필요한 경우, [<span style="color: #184FA1;">변경</span>]버튼을 클릭하여 새로운 카드를 등록해 주세요
                </span>
            </div>
            <div class="floating" v-if="isFloating">
                {{ floatingMessage }}
                <img class="close" @click="closeFloating" src="../assets/float-close.png" />
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex';
import TextLabel from '@/components/atoms/TextLabel';
import focusBackground from '@/components/directives/focusBackground';
import Constant from '@/constant';
import cookies from '@/utilities/cookie.js';
import CardChangeModal from '@/components/modals/CardChangeModal';
import ErrorModal from '@/components/modals/ErrorModal';
import Loading from '@/components/molecules/Loading';
import CommonModal from '@/components/modals/CommonModal';
export default {
    name: 'cardUpdate',
    computed: mapState(['diabetes_profiles', 'cardInfo']),
    components: {
        TextLabel,
        CardChangeModal,
        ErrorModal,
        Loading,
        CommonModal
    },
    directives: {
        focusBackground        
    },
    data: function()
    {
        return {
            activeProfileId: 0,
            token: null,
            isCardChangeModal: false,
            error: null,
            isLoading: false,
            profileId: 0,
            isCardDeleteModal: false,
            isFloating: false
        }
    },
    mounted: function()
    {
        ChannelIO('shutdown')
        this.token = cookies.getLocalStorage("access_token");
        if(this.token === null || this.token === undefined || this.token === '')
        {
            this.token = cookies.deleteLocalStorage("access_token");
            this.$router.push({path: '/', query: {returnUrl: 'apply'}})
        }
        else
        {
            
            // 유효성 체크    
            this.$store.dispatch(Constant.FETCH_PROFILES, {token: this.token})
                .then(() => {

                }) 
                .catch(() => {
                    this.token = cookies.deleteLocalStorage("access_token");
                    this.$router.push({path: '/', query: {returnUrl: 'apply'}})
                })
        }
    },
    methods: {
        onErrorModalClose: function()
        {
            this.error = null;
        },
        selectProfile: function(index)
        {
            this.activeProfileId = index
        }, 
        changeCard: function()
        {
            this.$store.commit(Constant.INITIALIZE_CARD_INFO);
            this.profileId = this.diabetes_profiles[this.activeProfileId].profile.id;
            // this.cardchange_request_data.profile.name = this.diabetes_profiles[this.activeProfileId].profile.name;
            // this.cardchange_request_data.profile.registration_number = this.diabetes_profiles[this.activeProfileId].profile.registration_number.replaceAll("-", "");

            // this.cardchange_request_data.profile.address = this.diabetes_profiles[this.activeProfileId].profile.address;
            // this.cardchange_request_data.profile.detail_address = this.diabetes_profiles[this.activeProfileId].profile.detail_address;
            // this.cardchange_request_data.profile.zip_code = this.diabetes_profiles[this.activeProfileId].profile.zip_code;
            // this.cardchange_request_data.profile.address_nickname = this.diabetes_profiles[this.activeProfileId].profile.address_nickname;


            this.isCardChangeModal = true;
        },
        onCloseCardChangeModal: function(flag)
        {
            if(flag)
            {
                this.setFloatingMessage('저장되었습니다.')
            }


            this.isLoading = true;
            this.$store.dispatch(Constant.FETCH_PROFILES, {token: this.token})
                .then(() => {
                    this.isLoading = false;
                }) 
                .catch(() => {
                    this.isLoading = false;
                    this.token = cookies.deleteLocalStorage("access_token");
                    this.$router.push({path: '/', query: {returnUrl: 'cardupdate'}})
                })


            this.isCardChangeModal = false;
        },
        back: function()
        {
            this.$router.push({path: '/home'})
        },
        deleteCard: function()
        {
            this.profileId = this.diabetes_profiles[this.activeProfileId].profile.id;
            this.isCardDeleteModal = true;
        },
        closeCardDeleteModal() {
            this.isCardDeleteModal = false;
        },
        deleteCardCall() {
            this.isLoading = true;
            // 삭제 수행 
            this.$store.dispatch(Constant.DELETE_CARD, {profile_id: this.profileId, token: this.token})
                .then(() => {
                    this.isCardDeleteModal = false;
                    this.isLoading = false;
                    this.setFloatingMessage('삭제되었습니다.')

                    this.$store.dispatch(Constant.FETCH_PROFILES, {token: this.token})
                        .then(() => {
                            this.isLoading = false;
                        }) 
                        .catch(() => {
                            this.token = cookies.deleteLocalStorage("access_token");
                            this.isLoading = false;
                            this.$router.push({path: '/', query: {returnUrl: 'apply'}})
                        })

                }) 
                .catch(() => {
                    this.isLoading = false;
                    this.token = cookies.deleteLocalStorage("access_token");
                    this.$router.push({path: '/', query: {returnUrl: 'apply'}})
                })
        },
        setFloatingMessage: function(message)
        {
            this.floatingMessage = message
            this.isFloating = true;

            setTimeout(() => {
                this.isFloating = false;
            }, 2000); // 2초 후 메시지 숨김
        },
        closeFloating: function()
        {
            this.isFloating = false;
        },
    }
}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .page {
        width: 100%;
        background: var(--Gray-20, #F3F5F8);
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        box-sizing: border-box;
    }

    @media (min-width: 600px) {
        .page {
            width: 600px;
        }
    }

    .contents-header {
        width: 100%;
        padding: 0 16px 30px 16px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        box-sizing: border-box;
    }
    .text1 {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 26px; /* 108.333% */
    }
    .text2 {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
    }
    .text3 {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 22px;
    }
    .contents-body {
        padding: 20px 16px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        width: 100%;
        background: var(--Gray-00, #FFF);
    }
    .register-button {
        border-radius: 6px;
        background: #6B7684;
        width: 100%;
        height: 39px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 9px 0 16px;
        box-sizing: border-box;
    }
    .row {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .col {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
    }
    .text4 {
        color: var(--Gray-primary-color2, #FFF);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 14px;
        letter-spacing: -0.32px;
    }
    .text5 {
        color: var(--gray-30-stroke, #E8EAEE);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 14px; /* 87.5% */
        letter-spacing: -0.32px;
    }
    .text6 {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    .text7 {
        color: #184FA1;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
    }
    .name-button-list {
        display: flex;
        width: 100%;
        justify-content: flex-start;
        align-items: center;
        overflow-x: scroll;
    }
    .name-button-active {
        width: 104px;
        height: 53px;
        border-radius: 6px;
        background: #184FA1;
        color: var(--Gray-00, #FFF);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .name-button-inactive {
        width: 104px;
        height: 53px;
        border-radius: 6px;
        background: var(--Gray-sub-color1, #F3F5F8);
        color: #1E1E1E;
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .input-big {
        width: 100%;
        height: 48px;
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        padding-left: 16px;
        padding-right: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        border-radius: 6px;
        box-sizing: border-box;
    }
    input::placeholder {
        color: var(--Gray-50, #A3AAB6);
    }
    .info-text {
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 111.111% */
    }
    .info-color-text {
        color: #184FA1;
    }
    .card-area {
        width: 100%;
        border-radius: 6px;
        background: var(--Gray-20, #F3F5F8);
        box-sizing: border-box;
        padding: 20px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }
    .card-update-button {
        display: flex;
        height: 28px;
        padding: 0 8px;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        border-radius: 100px;
        border: 1px solid var(--gray-40-button-stroke, #D1D6DB);
        background: var(--Gray-00, #FFF);
        color: #1D4A94;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        cursor: pointer;
    }
    .button-wrapper {
        width: 100%;
    }
    .button-header {
        width: 100%;
        height: 75px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 20.32px 15.5px;
        box-sizing: border-box;
    }
    .plus-button {
        border-radius: 10px;
        border: 1px dashed var(--Gray-50, #A3AAB6);
        background: var(--Gray-20, #F3F5F8);
        width: 100%;
        color: var(--Gray-100, #1E1E1E);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 100% */
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        height: 62px;
        cursor: pointer;
    }
    .floating {
        width: calc(100% - 32px);
        max-width: calc(568px);
        position: fixed;
        z-index: 999;
        border-radius: 6px;
        background: var(--Gray-60, #6B7684);
        backdrop-filter: blur(2px);
        height: 57px;
        left: 50%;
        bottom: 32px;
        transform: translate(-50%, 0);
        padding: 0 30px 0 20px;
        box-sizing: border-box;
        color: #FFF;
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .close {
        position: absolute;
        top: 17px;
        right: 8px;
        width: 22px;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/page/CardUpdate.vue